<template>
    <div class="tw-mb-4">
        <div class="tw-flex tw-mb-4">
            <div class="tw-w-4 tw-h-4 tw-mr-4">
                <i aria-hidden="true" :class="`${icon}`"></i>
            </div>
            <p class="tw-font-bold tw-text-lg">{{ label }}</p>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'EditInput',
    props: ['label', 'icon']
}
</script>